// extracted by mini-css-extract-plugin
var _1 = "d_UGwvWQoV";
var _2 = "hm_wtJkuQd";
var _3 = "wsdjfglNy3";
var _4 = "yB6enBwkHM";
export { _1 as "disabled", _2 as "icon", _3 as "label", _4 as "root" }
